<template>
	<div style="background-color: #fff;padding: 20px;" class="container-top">
		<!-- 右上角 返回按钮 -->
		<div class="header">
			<a-button @click="goBack" class="back-btn">
				<a-icon type="left" /> 返回
			</a-button>
		</div>
		<div style="display: flex; align-items: center; margin-bottom: 30px;">
			<!-- 左侧占位，与下方头像列等宽 -->
			<div style="width: 100px; margin-right: 32px;" class="title">用户信息</div>
			<!-- 右侧：标题 + 状态控件，与 a-descriptions 对齐 -->
			<div style="flex: 1; display: flex; align-items: center; flex-wrap: wrap;">
				<div style="margin-left: 12px;">用户状态：</div>
				<a-switch :checked="detailModel.userStatus" @change="(checked) => handlePublishChange(checked)" />
				<a-tag style="margin-left: 10px;" color="#2CBD9C" v-if="detailModel.userStatus === true && !detailModel.blackStatus">
					正常
				</a-tag>
				<a-tag style="margin-left: 10px;" color="#ff4d4f" v-if="detailModel.userStatus === false && detailModel.freezeType">
					{{ detailModel.freezeValue }}{{ detailModel.freezeType === 'DAY' ? '天' : detailModel.freezeType === 'HOUR' ? '小时' : detailModel.freezeType === 'FOREVER' ? '永久' : '' }}
				</a-tag>
				<a-tag style="margin-left: 10px; background: #000; color: #fff; border-color: #000;" v-if="detailModel.blackStatus">
					黑名单
				</a-tag>
				<span style="margin-left: 8px; font-size: 13px; color: #999;" v-if="detailModel.freezeType === 'DAY' || detailModel.freezeType === 'HOUR'">
					（{{ detailModel.freezeEndTime }}恢复）
				</span>
				<a-popconfirm :title="`确认将${detailModel.nickname}用户加入黑名单，该用户将不可进行评价及留言操作？`" okText="确定" cancelText="取消" @confirm="handleAddBlack">
					<a-button v-if="!detailModel.blackStatus" type="link" style="margin-left: 4px;">加入黑名单</a-button>
				</a-popconfirm>
				<a-popconfirm :title="`确认将${detailModel.nickname}用户解除黑名单，该用户将恢复前端评价及留言操作？`" okText="确定" cancelText="取消" @confirm="handleAddBlack">
					<a-button v-if="detailModel.blackStatus" type="link" style="margin-left: 4px;">取消黑名单</a-button>
				</a-popconfirm>
			</div>
		</div>



		<div style="display: flex; align-items: center;">
			<!-- 左侧：头像 + 地区 -->
			<div style="text-align: center; margin-right: 32px;">
				<viewer :images="[detailModel.avatar]">
					<img :src="detailModel.avatar" style="width: 100px; height: 100px; border-radius: 50%; margin-bottom: 8px; cursor: pointer;" />
				</viewer>
				<div style="font-size: 16px; font-weight: 500;">{{detailModel.country}}</div>
			</div>

			<!-- 右侧：用户信息列表 -->
			<a-descriptions :column="2" bordered style="flex: 1;">
				<a-descriptions-item label="用户ID">
					{{detailModel.userId}}{{detailModel.phone != null ? "(注册用户)":"(游客)"}}
				</a-descriptions-item>
				<a-descriptions-item label="性别">
					{{detailModel.sex==1?"男":detailModel.sex==2?"女":"未知" }}
				</a-descriptions-item>

				<a-descriptions-item label="昵称">
					{{detailModel.nickname}}
				</a-descriptions-item>
				<a-descriptions-item label="生日">
					{{detailModel.birthday}}
				</a-descriptions-item>

				<a-descriptions-item label="城市">
					{{detailModel.province}}{{detailModel.city}}
				</a-descriptions-item>
							<a-descriptions-item label="使用设备">
					{{ detailModel.deviceType == "IOS" ? "苹果":( detailModel.deviceType=="ANDROID" ? "安卓" : "") }}
				</a-descriptions-item>

				<a-descriptions-item label="首次登录时间">
					{{detailModel.firstLoginTime}}
				</a-descriptions-item>
				<a-descriptions-item label="最近浏览时间">
					{{detailModel.lastLoginTime}}
				</a-descriptions-item>
			</a-descriptions>
		</div>

		<div class="titleCz">操作日志</div>
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
		</a-table>


		<!-- 冻结期限 -->
		<a-modal :title="freePopModal.title" :visible="freePopModal.flag" width="600px" @ok="freePopModal.onOk"
			@cancel="freePopModal.flag = false">
			<div style="padding: 20px 0;">
				<a-radio-group v-model="freePopModal.freezeType" @change="onChange">
				<a-row style="margin-bottom: 20px; align-items: center;">
					<a-col :span="2" style="line-height: 32px;">
						<a-radio :value="'DAY'"></a-radio>
					</a-col>
					<a-col :span="18">
						<a-input v-model.number="freePopModal.freezeDays" placeholder="请输入天数（整数）"
								 :disabled="freePopModal.freezeType !== 'DAY'"
								 oninput="value=value.replace(/\D/g,'').trim()"/>
					</a-col>
					<a-col :span="4" style="line-height: 32px;">
						天
					</a-col>
				</a-row>

				<!-- 选项2：小时+分钟 -->
				<a-row style="margin-bottom: 20px; align-items: center;">
					<a-col :span="2" style="line-height: 32px;">
						<a-radio :value="'HOUR'"></a-radio>
					</a-col>
					<a-col :span="18">
						<a-input v-model.number="freePopModal.freezeHours" placeholder="24小时内"
								 :disabled="freePopModal.freezeType !== 'HOUR'"
								 oninput="value=value.replace(/\D/g,'').trim()"/>
					</a-col>
					<a-col :span="4" style="line-height: 32px;">小时</a-col>
				</a-row>
				<!-- 选项3：永久 -->
				<a-row style="align-items: center;">
					<a-col :span="2" style="line-height: 32px;">
						<a-radio :value="'FOREVER'"></a-radio>
					</a-col>
					<a-col :span="22" style="line-height: 32px;">
						永久
					</a-col>
				</a-row>
				</a-radio-group>
			</div>

		</a-modal>

	</div>
</template>

<script>
	import {
		userDetailApi,
		operationLogApi,
		userStatusApi,
		userBlackApi
	} from "../../api/index";

	export default {
		name: "VIPDETAIL",
		data() {
			return {
				//   详情
				detailModel: {
					"userId": 1,
					"openid": "", //openid
					"avatar": "", //头像
					"nickname": "", //用户名称
					"phone": "", //手机号码
					"sex": 1, //性别1时是男性，值为2时是女性，值为0时是未知
					"country": "", //国家
					"province": "", //所在地  省
					"city": "", //所在地  城市
					"deviceType": "", //使用设备 IOS 、ANDROID
					"registerStatus": true, //是否注册  true 是 false 否
					"firstLoginTime": "", //首次登录时间
					"lastLoginTime": "", //最近登录时间
					"userStatus": true, //账户状态
					"blackStatus": false, //是否加入黑名单
					"freezeType": "", //冻结状态 DAY 天  HOUR 小时  FOREVER 永久
					"freezeValue": "", //冻结值
					"freezeEndTime": "", //冻结结束日期
					"birthday": "" //生日
				},
				commodityStatusList: [{
						label: "开启",
						value: true,
					},
					{
						label: "关闭",
						value: false,
					},
				],
				columns: [{
						title: "操作员",
						dataIndex: "operator",
						key: "operator",
					},
					{
						title: "操作",
						dataIndex: "operation",
						key: "operation",
					},
					{
						title: "时间",
						dataIndex: "operationTime",
						key: "operationTime",
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				userId: null,
				selectedOperate: undefined, // 下拉选中值
				freePopModal: {
					flag: false,
					title: "",
					userId: "",
					freezeType: 'DAY', // 默认选中：1-天 2-时分 3-永久
					freezeValue: '',
					freezeDays: '',
					freezeHours: '',
					freezeMinutes: '',
					onOk: () => {},
				},

			};
		},
		methods: {
			onChange() {

			},
			openFreezeModal(record) {
				this.freePopModal = {
					flag: true,
					title: "冻结期限",
					freezeType: "DAY",
					onOk: () => {
						// 确认后执行的操作
						// record.userStatus = checked ? true : false;
						// 这里可以调用接口更新状态
						// 必填
						if (!this.freePopModal.freezeType) {
							this.$message.error("请选择冻结期限");
							return;
						}

						if (this.freePopModal.freezeType === 'DAY') {
							if (!this.freePopModal.freezeDays && this.freePopModal.freezeDays !== 0) {
								// 如果为空但非0，报错
								this.$message.error("请输入冻结天数");
								return;
							}
							if (this.freePopModal.freezeDays === 0) {
								this.$message.error("冻结天数不能为0");
								return;
							}
						}

						if (this.freePopModal.freezeType === 'HOUR') {
							const { freezeHours, freezeMinutes } = this.freePopModal;
							if (!freezeHours && !freezeMinutes) {
								this.$message.error("请输入冻结时间");
								return;
							}
							if (freezeHours === 0 && freezeMinutes === 0) {
								this.$message.error("冻结时间不能都为0");
								return;
							}
						}
						let params = {
							'userId': this.userId,
							"freezeType": this.freePopModal.freezeType,
							// "freezeValue": ""
						}

						// 赋值 freezeValue
						if (this.freePopModal.freezeType == "DAY") {
							params.freezeValue = this.freePopModal.freezeDays;

						} else if (this.freePopModal.freezeType == "HOUR") {
							// 小时：格式化为 HH:MM，空值补 0
							const h = this.freePopModal.freezeHours || 0;
							const m = this.freePopModal.freezeMinutes || 0;
							params.freezeValue = `${h}:${m}`;

						} else if (this.freePopModal.freezeType == "FOREVER") {
							// 永久冻结：可传空 / 固定值，按接口要求来
							params.freezeValue = "";
						}

						userStatusApi(params)
							.then((res) => {
								if (res.resultStatus) {
									this.$message.success("冻结成功");
								} else {
									console.log("res", res);
								}
							})
							.catch((error) => {
								console.log(error);
							})
							.finally(() => {
								this.freePopModal.flag = false
								this.getData();
								this.toDetail(this.userId)
								this.selectedOperate = undefined; // 重置下拉
							});

					},
					onCancel: () => {}
				};
			},
			// 下拉选中触发
			handleSelectOperate(val) {
				this.selectedOperate = val;
				const uid = this.userId;
				// 选中后分分支弹窗
				switch (val) {
					// 1、恢复正常
					case 'NORMAL':
						this.$confirm({
							title: '确认将用户恢复为正常状态？',
							content: `确认将用户恢复为正常状态？`,
							okText: '确定',
							cancelText: '取消',
							onOk: () => {
								userStatusApi({
									userId: uid,
									freezeType: null,
									freezeValue: null
								}).then(() => {
									this.getData();
									this.$message.success("成功");
									this.toDetail(this.userId)
									this.selectedOperate = undefined; // 重置下拉
								})
							},
							onCancel: () => {
								console.log('已取消操作');
							}
						});
						break;

						// 2、按天数冻结，打开时长弹窗
					case 'DAY':

						this.openFreezeModal({
							freezeType: "Day",
							freezeValue: ""
						});
						break;

						// 3、按时分冻结，打开时长弹窗
					case 'HOUR':
						this.openFreezeModal({
							freezeType: "HOUR",
							freezeValue: ""
						});
						break;

						// 4、永久冻结
					case 'FOREVER':
						this.openFreezeModal({
							freezeType: "FOREVER",
							freezeValue: ""
						});
						break;

						// 5、加入黑名单
					case 'ADD_BLACK':

						this.$confirm({
							title: '加入黑名单',
							content: `加入黑名单`,
							okText: '确定',
							cancelText: '取消',
							onOk: () => {
								userBlackApi({
										userId: data.userId,
									})
									.then((res) => {
										if (res.resultStatus) {
											this.getData();
											this.toDetail(this.userId)
											this.selectedOperate = undefined; // 重置下拉
											this.$message.success("加入黑名单成功");
										} else {
											console.log("res", res);
										}
									})
							},
							onCancel: () => {
								console.log('已取消操作');
							}
						});
						break;

						// 6、取消黑名单
					case 'REMOVE_BLACK':


						this.$confirm({
							title: '取消黑名单',
							content: `取消黑名单`,
							okText: '确定',
							cancelText: '取消',
							onOk: () => {
								userBlackApi({
										userId: data.userId,
									})
									.then((res) => {
										if (res.resultStatus) {
											this.getData();
											this.toDetail(this.userId)
											this.selectedOperate = undefined; // 重置下拉
											this.$message.success("加入黑名单成功");
										} else {
											console.log("res", res);
										}
									})
							},
							onCancel: () => {
								console.log('已取消操作');
							}
						});

						break;
				}
			},
			// 切换用户状态开关
			handlePublishChange(checked) {
				if (this.detailModel.userStatus) {
					// 当前正常 → 关闭 → 打开冻结弹窗
					this.openFreezeModal({
						freezeType: this.detailModel.freezeType || 'DAY',
						freezeValue: this.detailModel.freezeValue || ''
					});
				} else {
					this.$confirm({
						title: `确认取消对"${this.detailModel.nickname}"用户的冻结？`,
						content: '该用户将恢复前端全部操作',
						okText: '确认',
						cancelText: '取消',
						onOk: () => {
							let params = {
								'userId': this.userId,
							}
							userStatusApi(params)
								.then((res) => {
									if (res.resultStatus) {
										this.$message.success("解冻成功");
									} else {
										console.log("res", res);
									}
								})
								.catch((error) => {
									console.log(error);
								})
								.finally(() => {
									this.freePopModal.flag = false
									this.loading = false;
									this.getData();
									this.toDetail(this.userId)
								});
						},
						onCancel: () => {}
					});
				}
			},
			// 加入/取消黑名单
			handleAddBlack() {
				userBlackApi({
					userId: this.userId,
				}).then((res) => {
					if (res.resultStatus) {
						this.getData();
						this.toDetail(this.userId);
						this.$message.success(this.detailModel.blackStatus ? '取消黑名单成功' : '加入黑名单成功');
					}
				});
			},
			goBack() {
				this.$router.back();
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			toDetail(userId) {
				userDetailApi({
					userId: userId,
				}).then((res) => {
					if (res.resultStatus) {
						const result = res.resultData;
						this.detailModel=result

						// this.detailModel = {
						// 	userId: result?.userId ?? '',
						// 	openid: result?.openid ?? '',
						// 	avatar: result?.avatar ?? '',
						// 	nickname: result?.nickname ?? '',
						// 	phone: result?.phone ?? '',
						// 	sex: result?.sex != null ? result.sex : '',
						// 	country: result?.country ?? '',
						// 	province: result?.province ?? '',
						// 	city: result?.city ?? '',
						// 	deviceType: result?.deviceType ?? '',
						// 	registerStatus: result?.registerStatus != null ? result.registerStatus : null,
						// 	firstLoginTime: result?.firstLoginTime ?? '',
						// 	lastLoginTime: result?.lastLoginTime ?? '',
						// 	userStatus: result?.userStatus != null ? result.userStatus : null,
						// 	blackStatus: result?.blackStatus != null ? result.blackStatus : null,
						// 	freezeType: result?.freezeType ?? '',
						// 	freezeEndTime: result?.freezeEndTime ?? '',
						// 	birthday: result?.birthday ?? ''
						// };

						console.log(this.detailModel.freezeType, '看看这个是哪里的============')

						if (this.detailModel.blackStatus == true) {
							this.selectedOperate = "ADD_BLACK";
						} else if (this.detailModel.freezeType == "DAY") {
							this.selectedOperate = "DAY";
						} else if (this.detailModel.freezeType == "HOUR") {
							this.selectedOperate = "HOUR";
						} else if (this.detailModel.freezeType == "FOREVER") {
							// 后端返回FOREVER，精准赋值
							this.selectedOperate = "FOREVER";
						} else {
							// 无冻结、非黑名单
							this.selectedOperate = "NORMAL";
						}
					} else {
						this.$message.warn(res.errorMessage);
						this.detailModel = {
							"userId": 1,
							"openid": "", //openid
							"avatar": "", //头像
							"nickname": "", //用户名称
							"phone": "", //手机号码
							"sex": 1, //性别1时是男性，值为2时是女性，值为0时是未知
							"country": "", //国家
							"province": "", //所在地  省
							"city": "", //所在地  城市
							"deviceType": "", //使用设备 IOS 、ANDROID
							"registerStatus": true, //是否注册  true 是 false 否
							"firstLoginTime": "", //首次登录时间
							"lastLoginTime": "", //最近登录时间
							"userStatus": true, //账户状态
							"blackStatus": false, //是否加入黑名单
							"freezeType": "", //冻结状态 DAY 天  HOUR 小时  FOREVER 永久
							"freezeValue": "", //冻结值
							"freezeEndTime": "", //冻结结束日期
							"birthday": "" //生日
						};
					}
				});
			},

			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				operationLogApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						userId: this.userId,
						targetType: 'USER',
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];

							this.pageInfo.total = res.resultData.totalNum || 0;
							this.orderStaticsVO = res.resultData.userStatics
						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
		},
		mounted() {
			console.log()
			const id = this.$route.params.id;
			this.userId = id
			this.getData(1)
			this.toDetail(this.userId)
		},
		activated() {},
	};
</script>

<style lang="less" scoped>
	.container-top {
		padding: 20px;
		background-color: #fff;

		/* 右上角按钮 */
		.header {
			text-align: right;
			margin-bottom: 16px;
		}

		.title {
			font-size: 18px;
			color: #333333;
			line-height: 18px;
			// margin-bottom: 30px;
		}

		.titleCz {
			font-size: 18px;
			font-size: 18px;
			color: #333333;
			line-height: 18px;
			margin-bottom: 30px;
		}

		.ant-form-item {
			margin-bottom: 0px !important;
		}
	}
</style>
